<template>
    <div class="row mb-3">
        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label>Timecondition:</label>
        </div>
        <div v-if="isLoading" class="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
            <h5>Hold tight! We're loading your timeconditions..
                <font-awesome-icon :icon="['fal','spinner-third']" spin></font-awesome-icon>
            </h5>
        </div>
        <div v-show="isLoading === false" class="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
            <el-autocomplete
                v-if="hasTimeconditions"
                v-model="timecondition"
                :fetch-suggestions="querySearch"
                placeholder="Search Timeconditions"
                size="mini"
                class="width: 100%;"

                :clearable="true"
                @clear="handleTimeconditionClear"x
                @select="handleTimeconditionSelect"
            >
                <template slot-scope="{ item }">
                    <el-tooltip
                        :content="'This timecondition, called ' + item.name + ', is currently ' + (item.active ? 'active' : 'not active') + '.'"
                        effect="dark"
                        :open-delay="300"
                        placement="top">
                                                                    <span class="link">
                                                                        <font-awesome-icon
                                                                            v-bind:class="[{ 'text-danger': !item.active },{ 'text-success': item.active }]"
                                                                            :icon="['fal','clock']"></font-awesome-icon>
                                                                        <span class="pl-3">{{ item.name }}</span>
                                                                    </span>
                    </el-tooltip>
                </template>
                <template slot="append">
                    <el-tooltip
                        :content="'You\'ll be redirected to the timeconditions page to create a new one.'"
                        effect="dark"
                        :open-delay="300"
                        placement="top">
                        <router-link to="/timeconditions">
                            <span class="text-success"><font-awesome-icon
                                :icon="['fal','plus']"></font-awesome-icon></span>
                        </router-link>
                    </el-tooltip>
                </template>
            </el-autocomplete>
            <el-tooltip
                content="By default the flow is always active, even when no timecondition is present."
                effect="dark"
                :open-delay="300"
                placement="top">
            <span v-if="!hasTimeconditions">
                You have no timeconditions, you can create one <router-link to="/timeconditions">here</router-link>
             </span></el-tooltip>
        </div>
    </div>
</template>
<script>
    import {mapFields} from "vuex-map-fields";

    export default {
        name: 'timecondition-selector',
        props: {
            initialTimecondition: {
                default: 'Always',
            },
        },
        data() {
            return {
                timecondition: this.initialTimecondition + '',
            }
        },
        computed: {
            ...mapFields(`timecondition`, ['timeconditions']),
            hasTimeconditions: function () {
                if (this.$store.getters['timecondition/isLoading']) {
                    return true;
                }
                return this.timeconditions.length > 0;
            },
            isLoading: function () {
                return this.$store.getters['timecondition/isLoading'];
            }
        },
        methods: {
            loadTimeconditions() {
                if (this.$store.getters['timecondition/needUpdate']) {
                    this.$store.dispatch('timecondition/load').then(() => {
                        this.setTimecondition(this.timecondition);
                    });
                }
            },
            querySearch(queryString, cb) {
                let results = queryString ? this.timeconditions.filter(this.createFilter(queryString)).map(s => {
                    return {name: s.name, value: s.name, active: s.is_active, id: s.id,}
                }) : this.timeconditions.map(s => {
                    return {name: s.name, value: s.name, active: s.is_active, id: s.id}
                });
                cb(results);
            },
            createFilter(queryString) {
                return (timecondition) => {
                    return (timecondition.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0) || (timecondition.id === queryString);
                };
            },
            handleTimeconditionClear() {
                let id = '';
                this.$emit('update', {id});
            },
            handleTimeconditionSelect(timecondition) {
                this.timecondition = timecondition.value;
                let id = timecondition.id;
                this.$emit('update', {id});
            },
            setTimecondition(timeconditionID) {
                let timecondition = this.timeconditions.filter(t => t.id === timeconditionID)[0];
                if (timecondition) {
                    this.timecondition = timecondition.name;
                } else {
                    this.timecondition = 'Always';
                }

            },
        },
        mounted() {
            this.loadTimeconditions();
            this.setTimecondition(this.initialTimecondition);
        },
        watch: {
            initialTimecondition: function (newTime, oldTime) {
                this.setTimecondition(newTime);
            },
            timeconditions: function () {
                this.setTimecondition(this.initialTimecondition);
            },
        }
    }
</script>
<style scoped>
    .timeline li:not(.ui-sortable-helper):before {
        transition: border-width 0.6s linear;
    }

    .timeline > li {
        position: relative;
        margin-right: 10px;
        margin-bottom: 50px;
        padding-top: 18px;
        box-sizing: border-box;
    }

    .timeline > li:before,
    .timeline > li:after {
        display: block;
    }

    .timeline > li:not(.ui-sortable-helper):before {
        counter-increment: section;
        content: counter(section);
        background: #e14eca;
        width: 70px;
        height: 70px;
        position: absolute;
        top: 0;
        border-radius: 50%;
        left: -1px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #Fff;
        font-size: 22px;
        font-weight: bold;
        border: 15px solid #fff;
        box-sizing: border-box;
    }

    .timeline > li:after {
        clear: both;
    }

    .radio-thumbnail > label {
        border-radius: 4px;
    }

    .radio-thumbnail > input {
        display: none;
    }

    .radio-thumbnail > :checked + .thumbnail > span {
        border-radius: 0;
    }

    .thumbnail > span {
        position: absolute;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.65+100 */
        background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
        /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#a6000000', GradientType=0);
        /* IE6-9 */
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 20px;
        font-weight: 400;
        padding: 97px 0 0 16px;
        text-align: left;
        border-radius: 4px;
        border: 0;
    }

    .add-n-f i {
        border: 1px dotted #989898;
        width: 25px;
        height: 25px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }

    .add-n-f:hover i {
        color: #e14eca;
        border-color: #e14eca;
    }

    #sortable li {
        margin: 0 3px 3px 3px;
        padding: 0.4em;
        padding-left: 1.5em;
        font-size: 1.4em;
        height: 18px;
    }

    #sortable li span {
        position: absolute;
        margin-left: -1.3em;
    }
</style>
